import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import UserService from '@/services/UserService';
import NetworkService from '@/services/NetworkService';
import VueRecaptcha from '@/components/widget/VueRecaptcha';
import { validationMixin, useSpinValidate } from '@/plugins/vuelidateCompat';
import { required, email, requiredIf } from '@vuelidate/validators';
const cellPhone = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  } else {
    return /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value);
  }
};
export default {
  name: 'Contact',
  components: {
    VueRecaptcha
  },
  data() {
    return {
      openModal: false,
      categories: [{
        value: {
          id: 1,
          category: 'Questions about musical performances or competitions'
        },
        text: 'Questions about musical performances or competitions'
      }, {
        value: {
          id: 2,
          category: 'My Account'
        },
        text: 'My Account - Login, Subscription, Payment'
      }, {
        value: {
          id: 2,
          category: 'Bug Report'
        },
        text: 'Bug Report or problem with site'
      }],
      contact: {
        recaptchaResponse: null,
        category: null,
        firstname: null,
        lastname: null,
        email: null,
        phone: null,
        message: null
      },
      sitekey: '6Le-L6wZAAAAANrSopXo5MQU4rPseWwOZDndebHd',
      robot: true,
      isLoggedIn: false,
      loading: false
    };
  },
  methods: {
    openView() {
      UserService.getUserInfo().then(user => {
        if (user && user.apikey !== null) {
          this.isLoggedIn = true;
          this.contact.firstname = user.firstname;
          this.contact.lastname = user.lastname;
          this.contact.email = user.email;
        }
      });
      this.openModal = true;
    },
    resetModal() {
      this.contact = {
        recaptchaResponse: null,
        category: null,
        firstname: null,
        lastname: null,
        email: null,
        phone: null,
        message: null
      };
      this.$v.$reset();
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid || this.$v.contact.$anyError) {
        const errorTxt = this.robot && !this.isLoggedIn ? 'Recaptcha is required' : 'Double check your input';
        this.$aim.error(null, 'warn', 'Something is Missing', errorTxt);
        this.loading = false;
        return;
      }
      NetworkService.submitContactUs(this.contact).then(response => {
        this.openModal = false;
        this.$aim.notify(response, 'info', 'Thank You', 'Your report has been submitted and staff will get back to you as soon as possible');
      }, error => {
        this.$aim.error(error.response);
      }).finally(() => {
        this.loading = false;
      });
    },
    onVerify(response) {
      this.contact.recaptchaResponse = response;
      if (response) {
        this.robot = false;
        this.$v.contact.recaptchaResponse.$reset();
      }
    },
    getErrors(field, validators) {
      const err = [];
      if (!this.$v.contact[field].$dirty) return err;
      validators.forEach(e => {
        if (this.$v.contact[field][e].$invalid) {
          e === 'required' && err.push('This field is required');
          e === 'email' && err.push('Please enter a valid email');
          e === 'cellPhone' && err.push('Please enter a valid phone number');
        }
      });
      return err;
    }
  },
  mixins: [validationMixin],
  setup() {
    return useSpinValidate();
  },
  validations: {
    contact: {
      recaptchaResponse: {
        required: requiredIf(function () {
          return !this.isLoggedIn;
        })
      },
      category: {
        required
      },
      firstname: {
        required
      },
      lastname: {
        required
      },
      email: {
        required,
        email
      },
      phone: {
        required,
        cellPhone
      },
      message: {
        required
      }
    }
  }
};